export default  { 
    tipo:[
    {id:1, select:"Soldado"},
    {id:2, select:"Cabo"},
    {id:3, select:"3° Sargento"},
    {id:4, select:"2° Sargento"},
    {id:5, select:"1° Sargento"},
    {id:6, select:"Subtenente"},
    {id:7, select:"Aspirante a Oficial"},
    {id:8, select:"2° Tenente"},
    {id:9, select:"1° Tenente"},
    {id:10, select:"Capitão"},
    {id:11, select:"Major"},
    {id:12, select:"Tenente-coronel"},
    {id:13, select:"Coronel"},
    ]
    
 };